<section class="forbidden">
  <div class="forbidden__card">
    <h1>403</h1>
    <p>You don’t have permission to view this page.</p>
    <p class="hint">Please contact your administrator if you believe this is a mistake.</p>
  </div>
</section>

